import { KeyRound } from "lucide-react";
import { useState, type FormEvent } from "react";

import { BrandMark } from "../components/BrandMark";
import { PasswordField } from "../components/PasswordField";
import type { UserSession } from "../lib/trpc";
import { trpc } from "../lib/trpc";

/**
 * Il proprio accesso.
 *
 * Chi ha ricevuto una password temporanea dalla console viene mandato qui e non passa oltre
 * finche non ne sceglie una sua: una password che conosce anche chi l'ha generata non e la
 * password di nessuno. Chiunque altro ci arriva dal proprio nome, nel menu.
 */
export function ProfilePage({ session, forzato = false }: { session: UserSession; forzato?: boolean }) {
  const utils = trpc.useUtils();
  const [esito, setEsito] = useState<string | null>(null);
  const change = trpc.auth.changePassword.useMutation();

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const nuova = String(data.get("newPassword") ?? "").trim();
    const conferma = String(data.get("confirmPassword") ?? "").trim();
    if (nuova.length < 10) {
      setEsito("La password nuova deve avere almeno 10 caratteri.");
      return;
    }
    if (nuova !== conferma) {
      setEsito("Le due password nuove non coincidono.");
      return;
    }
    try {
      await change.mutateAsync({ currentPassword: String(data.get("currentPassword") ?? ""), newPassword: nuova });
      form.reset();
      setEsito("Password cambiata.");
      await utils.auth.me.invalidate();
    } catch (error) {
      setEsito(error instanceof Error ? error.message : "Cambio non riuscito.");
    }
  }

  const modulo = (
    <form className="editor-card" onSubmit={submit}>
      <div className="editor-card__heading">
        <h2>Cambia la password</h2>
        <p>{forzato
          ? "Hai ricevuto una password temporanea. Scegline una tua per continuare."
          : "Serve la password attuale, poi quella nuova due volte."}</p>
      </div>
      <div className="form-grid">
        <PasswordField className="form-grid__wide" label="Password attuale" name="currentPassword" required autoComplete="current-password" />
        <PasswordField label="Password nuova" name="newPassword" required autoComplete="new-password" />
        <PasswordField label="Ripeti la password nuova" name="confirmPassword" required autoComplete="new-password" />
      </div>
      {esito && <p className={esito === "Password cambiata." ? "notice" : "form-error"} role="status">{esito}</p>}
      <div className="form-actions">
        <button className={`button button--primary${change.isPending ? " button--saving" : ""}`}>
          {change.isPending ? "Salvataggio..." : "Cambia password"}
        </button>
      </div>
    </form>
  );

  if (forzato) {
    return (
      <main className="gate-page">
        <div className="gate-page__inner">
          <BrandMark />
          <span className="invite-card__icon"><KeyRound /></span>
          <h1>Scegli la tua password</h1>
          <p>Per {session.user.name}, in {session.company.name}.</p>
          {modulo}
        </div>
      </main>
    );
  }

  return (
    <main className="page">
      <header className="page-heading">
        <div>
          <p className="eyebrow">Il tuo accesso</p>
          <h1>Profilo</h1>
          <p>{session.user.name} · {session.user.email} · {session.company.name}</p>
        </div>
      </header>
      {modulo}
    </main>
  );
}
